export enum TimelineConstants {
  NOT_IMPLEMENTED = 'timeline/NOT_IMPLEMENTED',
  MONITOR_MODAL = 'timeline/MONITOR_MODAL',
  CAMERA_MODAL = 'timeline/CAMERA_MODAL',
  RESET_TIMELINE = 'timeline/RESET_TIMELINE',
  SET_SEGMENT = 'timeline/TIMELINE_SET_SEGMENT',
  FILTER_VITALS = 'timeline/FILTER_VITALS',
  FILTER_PROCEDURES = 'timeline/FILTER_PROCEDURES',
  FILTER_ASSESSMENTS = 'timeline/FILTER_ASSESSMENTS',
  FILTER_ECG = 'timeline/FILTER_ECG',
  FILTER_TIMES = 'timeline/FILTER_TIMES',
  FILTER_MEDICATIONS = 'timeline/FILTER_MEDICATIONS',
  CLEAR_FILTERS = 'timeline/CLEAR_FILTERS',
  ADD_TO_ACTIVITY_LOG = 'timeline/ADD_TO_ACTIVITY_LOG',
  SET_ACTIVITY_LOG = 'timeline/SET_ACTIVITY_LOG',
  SET_RESPONSE = 'timeline/SET_RESPONSE',
  ADD_VITALS = 'timeline/ADD_VITALS',
  SET_VITAL_ITEM = 'timeline/SET_VITAL_ITEM',
  SAVE_TIMELINE = 'timeline/SAVE_TIMELINE',
  SET_ADD_MEDICATION_ADMINISTERED_ITEM = 'timeline/SET_ADD_MEDICATION_ADMINISTERED_ITEM',
  ADD_MEDICATION_ADMINISTERED_ITEM = 'timeline/ADD_MEDICATION_ADMINISTERED_ITEM',
  SET_FILTERED_ITEMS = 'timeline/SET_FILTERED_ITEMS',
  ADD_INTUBATION_ITEM = 'timeline/ADD_INTUBATION_ITEM',
  SET_INTUBATION_PROCEDURE_ITEM = 'timeline/SET_INTUBATION_PROCEDURE_ITEM',
  SET_CARDIAC_PROCEDURE_ITEM = 'timeline/SET_CARDIAC_PROCEDURE_ITEM',
  ADD_CARDIAC_ITEM = 'timeline/ADD_CARDIAC_ITEM',
  SET_IMAGING_ULTRASOUND_ITEM = 'timeline/SET_IMAGING_ULTRASOUND_ITEM',
  ADD_IMAGING_ULTRASOUND_ITEM = 'timeline/ADD_IMAGING_ULTRASOUND_ITEM',
  SET_PN_MEDICATION_ITEM = 'timeline/SET_PN_MEDICATION_ITEM',
  ADD_PN_MEDICATION_ITEM = 'timeline/ADD_PN_MEDICATION_ITEM',
  ADD_TIMES_ITEM = 'timeline/ADD_TIMES_ITEM',
  SET_TIMES_ITEM = 'timeline/SET_TIMES_ITEM',
  DELETE_TIMELINE_ITEM = 'timeline/DELETE_TIMELINE_ITEM',
  SET_FILTER_CHIPS = 'timeline/SET_FILTER_CHIPS',
  SET_SHOW_CLEAR_FILTER_BUTTON = 'timeline/SET_SHOW_CLEAR_FILTER_BUTTON',
  UPDATE_FILTERED_ITEMS = 'timeline/UPDATE_FILTERED_ITEMS',
  SELECTED_FILTER_CHIP_TYPE = 'timeline/SELECTED_FILTER_CHIP_TYPE',
  SET_AIRWAY_PROCEDURE_ITEM = 'timeline/SET_AIRWAY_PROCEDURE_ITEM',
  ADD_AIRWAY_ITEM = 'timeline/ADD_AIRWAY_ITEM',
  SET_CHILDBIRTHOB_PROCEDURE_ITEM = 'timeline/SET_CHILDBIRTHOB_PROCEDURE_ITEM',
  ADD_CHILDBIRTHOB_ITEM = 'timeline/ADD_CHILDBIRTHOB_ITEM',
  SET_INITIATE_IV_PROCEDURE_ITEM = 'timeline/SET_INITIATE_IV_PROCEDURE_ITEM',
  ADD_INITIATE_IV_ITEM = 'timeline/ADD_INITIATE_IV_ITEM',
  SET_IMMOBILIZATION_PROCEDURE_ITEM = 'timeline/SET_IMMOBILIZATION_PROCEDURE_ITEM',
  ADD_IMMOBILIZATION_ITEM = 'timeline/ADD_IMMOBILIZATION_ITEM',
  SET_MEDICAL_CONSULT_PROCEDURE_ITEM = 'timeline/SET_MEDICAL_CONSULT_PROCEDURE_ITEM',
  ADD_MEDICAL_CONSULT_ITEM = 'timeline/ADD_MEDICAL_CONSULT_ITEM',
  SET_EXTRICATION_PROCEDURE_ITEM = 'timeline/SET_EXTRICATION_PROCEDURE_ITEM',
  ADD_EXTRICATION_ITEM = 'timeline/ADD_EXTRICATION_ITEM',
  SET_OPERATIONS_PROCEDURE_ITEM = 'timeline/SET_OPERATIONS_PROCEDURE_ITEM',
  ADD_OPERATIONS_ITEM = 'timeline/ADD_OPERATIONS_ITEM',
  SET_RESCUE_PROCEDURE_ITEM = 'timeline/SET_RESCUE_PROCEDURE_ITEM',
  ADD_RESCUE_ITEM = 'timeline/ADD_RESCUE_ITEM',
  SET_VENTILATOR_PROCEDURE_ITEM = 'timeline/SET_VENTILATOR_PROCEDURE_ITEM',
  ADD_VENTILATOR_ITEM = 'timeline/ADD_VENTILATOR_ITEM',
  SET_CRITICAL_CARE_PROCEDURE_ITEM = 'timeline/SET_CRITICAL_CARE_PROCEDURE_ITEM',
  ADD_CRITICAL_CARE_ITEM = 'timeline/ADD_CRITICAL_CARE_ITEM',
  SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM = 'timeline/SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM',
  ADD_HOSPITAL_NOTIFY_ITEM = 'timeline/ADD_HOSPITAL_NOTIFY_ITEM',
  SET_WOUND_CARE_PROCEDURE_ITEM = 'timeline/SET_WOUND_CARE_PROCEDURE_ITEM',
  ADD_WOUND_CARE_ITEM = 'timeline/ADD_WOUND_CARE_ITEM',
  SET_DRAIN_PROCEDURE_ITEM = 'timeline/SET_DRAIN_PROCEDURE_ITEM',
  ADD_DRAIN_ITEM = 'timeline/ADD_DRAIN_ITEM',
  SET_PROCEDURE_LOADER = 'timeline/SET_PROCEDURE_LOADER',
  SET_ACTIONS_LIST = 'timeline/SET_ACTIONS_LIST',
  SET_TITRATE_PROCEDURE_ITEM = 'timeline/SET_TITRATE_PROCEDURE_ITEM',
  ADD_TITRATE_ITEM = 'timeline/ADD_TITRATE_ITEM',
  ADD_LABS_ITEM = 'timeline/ADD_LABS_ITEM',
  SET_LABS_PROCEDURE_ITEM = 'timeline/SET_LABS_PROCEDURE_ITEM',
  ADD_PN_PROCEDURE_ITEM = 'timeline/ADD_PN_PROCEDURE_ITEM',
  SET_PN_PROCEDURE_ITEM = 'timeline/SET_PN_PROCEDURE_ITEM',
  SET_DELETE_VITALS_PROMPT = 'timeline/SET_DELETE_VITALS_PROMPT',
  SET_DELETE_PARENT_VITALS = 'timeline/SET_DELETE_PARENT_VITALS',
  DELETE_PARENT_VITALS = 'timeline/DELETE_PARENT_VITALS',
  RESET_TIMELINE_STATE = 'timeline/RESET_TIMELINE_STATE',
  SET_IS_EDIT_MODE = 'timeline/SET_IS_EDIT_MODE',
  SET_EDITED_KEYS = 'timeline/SET_EDITED_KEYS',
  SET_EDITED_ITEM = 'timeline/SET_EDITED_ITEM',
  SYNC_PTA_WITH_PARENT_VITALS = 'procedure/SYNC_PTA_WITH_PARENT_VITALS',
  SET_DELETE_PROCEDURE_PROMPT = 'procedure/SET_DELETE_PROCEDURE_PROMPT',
  SET_DELETE_PROCEDURE = 'procedure/SET_DELETE_PROCEDURE',
  SET_BLOOD_PRODUCT_ADMINISTRATION = 'timeline/SET_BLOOD_PRODUCT_ADMINISTRATION',
  ADD_BLOOD_PRODUCT_ADMINISTRATION = 'timeline/ADD_BLOOD_PRODUCT_ADMINISTRATION',
  SET_VENTRICULAR_ASSIST_DEVICE = 'timeline/SET_VENTRICULAR_ASSIST_DEVICE',
  ADD_VENTRICULAR_ASSIST_DEVICE = 'timeline/ADD_VENTRICULAR_ASSIST_DEVICE',
  SET_ASSESSMENT = 'timeline/SET_ASSESSMENT',
  ADD_ASSESSMENT = 'timeline/ADD_ASSESSMENT',

  IMAGING_ULTRASOUND_PROCEDURE = 'Imaging/Ultrasound',
  AIRWAY_PROCEDURE = 'Airway',
  VENTILATOR_PROCEDURE = 'Ventilator',
  CARDIAC_PROCEDURE = 'Cardiac',
  DRAIN_PROCEDURE = 'Drain',
  INITIATE_IV_PROCEDURE = 'Initiate IV',
  HOSPITAL_NOTIFY_PROCEDURE = 'Hosp. Notify',
  INTUBATION_PROCEDURE = 'Intubation',
  LABS_PROCEDURE = 'Labs',
  OPERATIONS_PROCEDURE = 'Operations',
  CHILDBIRTH_PROCEDURE = 'Childbirth',
  EXTRICATION_PROCEDURE = 'Extrication',
  IMMOBILIZATION_PROCEDURE = 'Immobilization',
  MEDICAL_CONSULT_PROCEDURE = 'Medical Consult',
  RESCUE_PROCEDURE = 'Rescue',
  WOUND_CARE_PROCEDURE = 'Wound Care',
  BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE = 'Blood Product Administration',
  VENTRICULAR_ASSIST_DEVICE_PROCEDURE = 'Ventricular Assist Device',
  CRITICAL_CARE_PROCEDURE = 'Critical Care',
  ASSESSMENT = 'Assessments',
}
